module.exports = __webpack_public_path__ + "static/media/illust04.f2abc574.PNG";